import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import {CdkStepperModule} from '@angular/cdk/stepper';

import { WizardActionComponent } from './wizard-action.component';

import { WizardActionGoRutasModule } from './action/action.rutas.module';


@NgModule({
  declarations: [WizardActionComponent],
  imports     : [
      //RouterModule.forChild(routes),
      //routes,
      RouterModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      MatTooltipModule,
      MatStepperModule,
      CdkStepperModule,
      TranslateModule,
      FuseSharedModule,
      FuseSidebarModule,
      WizardActionGoRutasModule,

  ],
  exports     : [
      WizardActionComponent
  ]
})
export class WizardActionModule { }
